var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.items,"item-text":_vm.campoExibir,"item-value":_vm.campoChave,"outlined":"","dense":"","chips":_vm.chips,"small-chips":_vm.smallchips,"label":_vm.label,"multiple":_vm.multiple},model:{value:(_vm.selecao),callback:function ($$v) {_vm.selecao=$$v},expression:"selecao"}})
}
var staticRenderFns = []

export { render, staticRenderFns }